import { render, staticRenderFns } from "./editorWrapper.vue?vue&type=template&id=1d833b48&scoped=true&"
import script from "./editorWrapper.vue?vue&type=script&lang=js&"
export * from "./editorWrapper.vue?vue&type=script&lang=js&"
import style0 from "./editorWrapper.vue?vue&type=style&index=0&id=1d833b48&prod&lang=css&"
import style1 from "./editorWrapper.vue?vue&type=style&index=1&id=1d833b48&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d833b48",
  null
  
)

export default component.exports